import { render, staticRenderFns } from "./CreateOrganization.vue?vue&type=template&id=1f3cfd0e"
import script from "./CreateOrganization.vue?vue&type=script&lang=ts"
export * from "./CreateOrganization.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports